export const copyToClipboard = (text) => {
  try {
    navigator.clipboard.writeText(text);
    return true;
  } catch (e) {
    console.warn('Clipboard warning:', e);
    return false;
  }
};
